import { render, staticRenderFns } from "./ClientAnatomy.vue?vue&type=template&id=349f11fc"
import script from "./ClientAnatomy.vue?vue&type=script&lang=js"
export * from "./ClientAnatomy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports